import PropTypes from 'prop-types';
import {
  analyticsFormat,
  analyticsScope,
  createNavigationClickEventData,
  createUsageEventData,
  NavigationClickEventDataPropTypes,
  UsageEventDataPropTypes,
} from './adobe';

function createButtonClickEventData(buttonType) {
  return { buttonType };
}

const ButtonClickEventDataPropTypes = {
  buttonType: PropTypes.string,
};

export function createPiiEventData(eventLocation, usageEventData, pii) {
  const { documentType, contentType, documentSubtype } = usageEventData;
  const id = `sd:${documentType}:pii:${pii}`;
  const typePrefix = `sd:${documentType}:${contentType}`;
  const detail = `sd:${documentType}:subtype:${documentSubtype}:tool:${eventLocation}`;

  return {
    previewContentView: createUsageEventData(id, `${typePrefix}:${analyticsScope.ABSTRACT}`, analyticsFormat.MIME_XHTML, detail),
    savePdf: createUsageEventData(id, `${typePrefix}:${analyticsScope.FULL}`, analyticsFormat.MIME_PDF, detail),
    viewPdf: createNavigationClickEventData(eventLocation, 'view-pdf'),
  };
}

export function createDoiEventData(eventLocation) {
  return {
    viewAtPublisher: createNavigationClickEventData(eventLocation, 'publisher-name'),
  };
}

function createOptionalEvents(eventLocation, usageEventData, identifiers) {
  const { pii, doi } = identifiers;

  if (pii) {
    return createPiiEventData(eventLocation, usageEventData, pii);
  }

  if (doi) {
    return createDoiEventData(eventLocation);
  }

  return {};
}

export default function createArticleEvents(eventLocation, usageEventData, identifiers) {
  return {
    titleClick: createNavigationClickEventData(eventLocation, 'article-name'),
    preview: createButtonClickEventData(`${eventLocation}:preview`),
    ...createOptionalEvents(eventLocation, usageEventData, identifiers),
  };
}

const articleEventsPropTypes = {
  titleClick: PropTypes.shape(NavigationClickEventDataPropTypes),
  preview: PropTypes.shape(ButtonClickEventDataPropTypes),
};

export const DoiArticleEventsPropTypes = {
  ...articleEventsPropTypes,
  viewAtPublisher: PropTypes.shape(NavigationClickEventDataPropTypes),
};

export const PiiArticleEventsPropTypes = {
  ...articleEventsPropTypes,
  previewContentView: PropTypes.shape(UsageEventDataPropTypes),
  savePdf: PropTypes.shape(UsageEventDataPropTypes),
  viewPdf: PropTypes.shape(NavigationClickEventDataPropTypes),
};

export const ArticleEventsPropTypes = PropTypes.oneOfType([
  PropTypes.shape(DoiArticleEventsPropTypes),
  PropTypes.shape(PiiArticleEventsPropTypes),
]);
